export default "__VITE_ASSET__340b76cf__"